import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => (
  <div className="auth-layout">
    <Outlet />
  </div>
);

export default AuthLayout;
